import { createContext } from 'react';

interface DeviceContextType {
  isMobileApp: boolean;
}

export const DeviceContext = createContext<DeviceContextType>({
  isMobileApp: false,
});
